import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { ModalBody, Button, Modal } from "reactstrap";
import * as loaderAction from "../../redux/loader/action";
// import playerImg from "../../../assets/images/avatar2.png";
import closeImg from "../../assets/images/close2.png";
import Socket from "../../socket/socket";
import _ from "lodash";

const InGameJoinTeam = (props) => {
  const roomData = _.get(props, "gameReducer.roomObj");

  return (
    <>
      <div className="add-player-modal">
        <Modal
          centered
          isOpen={true}
          className="add-player-modal"
          //   toggle={toggle}
        >
          <ModalBody className="add-player-modal">
            <h3 className="heading">Add player(s)? </h3>
            <p className="desc">
              The following player(s) would like to join your game. Adding a
              player will also add them to your team account.
            </p>
            <div className="added-player-wrapper">
              <div className="added-player-list">
                {props.users &&
                  props.users.length > 0 &&
                  props.users.map((user, index) => {
                    return (
                      <div key={index} className="added-player-flex">
                        <img
                          src={user?.profile_image}
                          className="profile_image"
                          alt=""
                        />
                        <p className="name">{user?.display_name}</p>

                        <img
                          onClick={() =>
                            props.handle_reject_join_team([{ ...user }])
                          }
                          src={closeImg}
                          className="closeImg"
                          alt=""
                        />
                      </div>
                    );
                  })}
              </div>
              <div className="yes-no-btn">
                <p>Add new license(s)? </p>
                <Button
                  className="no"
                  onClick={() =>
                    props.handle_reject_join_team([...props.users])
                  }
                >
                  No
                </Button>
                <Button
                  className="yes"
                  onClick={() =>
                    props.handle_accept_join_team([...props.users])
                  }
                >
                  Yes
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(InGameJoinTeam);
